import React from 'react';

export default function CallButton({ classname, clickAction, component }) {
    return (
        <button className={"cursor-pointer btn btn-outline " + classname} onClick={clickAction}>
            {component}
        </button>
    )
}